import React from 'react'
import { FiCheck, FiX, FiSettings, FiUser, FiChevronDown, FiChevronUp, FiMusic, FiPlusCircle, FiHeadphones } from 'react-icons/fi'

interface HeaderProps {
  isSpotifyConnected: boolean
  isGeminiConfigured: boolean
  currentMood: string | null
  onResetMood: () => void
  onSettingsClick: () => void
}

const Header: React.FC<HeaderProps> = ({
  isSpotifyConnected,
  isGeminiConfigured,
  currentMood,
  onResetMood,
  onSettingsClick
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)
  
  return (
    <header className="bg-spotify-dark text-white p-3 shadow-md w-full sticky top-0 z-10">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex items-center justify-center bg-spotify-green h-8 w-8 rounded-full mr-2">
            <FiHeadphones className="h-5 w-5 text-white" />
          </div>
          <h1 className="text-xl font-bold">Moodio</h1>
        </div>
        
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-1 mr-2">
            <div className="hidden md:flex items-center">
              <span className="text-xs text-spotify-text-gray mr-1">Spotify:</span>
              {isSpotifyConnected ? (
                <span className="flex items-center text-xs text-spotify-green">
                  <FiCheck className="mr-0.5" />
                  <span>Connected</span>
                </span>
              ) : (
                <span className="flex items-center text-xs text-spotify-error">
                  <FiX className="mr-0.5" />
                  <span>Not connected</span>
                </span>
              )}
            </div>
            
            <div className="hidden md:flex items-center ml-3">
              <span className="text-xs text-spotify-text-gray mr-1">Gemini:</span>
              {isGeminiConfigured ? (
                <span className="flex items-center text-xs text-spotify-green">
                  <FiCheck className="mr-0.5" />
                  <span>Configured</span>
                </span>
              ) : (
                <span className="flex items-center text-xs text-spotify-error">
                  <FiX className="mr-0.5" />
                  <span>Not configured</span>
                </span>
              )}
            </div>
          </div>
          
          {/* Desktop button */}
          <button
            className="px-3 py-1.5 text-sm font-medium rounded-full transition-colors hover:bg-spotify-dark-tint"
            onClick={onSettingsClick}
          >
            <span className="flex items-center">
              <FiSettings className="mr-1" />
              <span>Settings</span>
            </span>
          </button>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden flex items-center text-sm"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <FiUser className="mr-1" />
            <span>Menu</span>
            {mobileMenuOpen ? <FiChevronUp className="ml-1" /> : <FiChevronDown className="ml-1" />}
          </button>
        </div>
      </div>
      
      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-2 bg-spotify-dark-tint rounded-lg overflow-hidden">
          <nav className="flex flex-col">
            <button
              className="px-4 py-3 text-left text-sm font-medium transition-colors hover:bg-spotify-dark"
              onClick={() => {
                onSettingsClick();
                setMobileMenuOpen(false);
              }}
            >
              <span className="flex items-center">
                <FiSettings className="mr-2" />
                <span>Settings</span>
              </span>
            </button>
            
            <div className="border-t border-spotify-dark">
              <div className="px-4 py-3">
                <div className="flex items-center mb-2">
                  <span className="text-xs text-spotify-text-gray mr-1">Spotify:</span>
                  {isSpotifyConnected ? (
                    <span className="flex items-center text-xs text-spotify-green">
                      <FiCheck className="mr-0.5" />
                      <span>Connected</span>
                    </span>
                  ) : (
                    <span className="flex items-center text-xs text-spotify-error">
                      <FiX className="mr-0.5" />
                      <span>Not connected</span>
                    </span>
                  )}
                </div>
                
                <div className="flex items-center">
                  <span className="text-xs text-spotify-text-gray mr-1">Gemini:</span>
                  {isGeminiConfigured ? (
                    <span className="flex items-center text-xs text-spotify-green">
                      <FiCheck className="mr-0.5" />
                      <span>Configured</span>
                    </span>
                  ) : (
                    <span className="flex items-center text-xs text-spotify-error">
                      <FiX className="mr-0.5" />
                      <span>Not configured</span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          </nav>
        </div>
      )}
    </header>
  )
}

export default Header

/* Add this to your global CSS or tailwind.config.js */
/* 
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeIn {
  animation: fadeIn 0.2s ease-out forwards;
}
*/ 